/** @file Signed distance from the pivot to a tile edge along that edge's outward normal (image px). */
import { TILE_EDGES, type TileEdge } from '@zilo/pose3d-render-core/cut/tileEdges';

/** `size - p` for a far edge (bottom, right), `p` for a near one (top, left), on the edge's axis. */
export function edgeDistanceOf(edge: TileEdge, pivot: [number, number], texW: number, texH: number): number {
  const e = TILE_EDGES[edge];
  const p = pivot[e.axis];
  return e.far ? (e.axis === 0 ? texW : texH) - p : p;
}
